<template>
    <div>
        <div class="map" v-if="!gpsData">
            <img class="no-gps" name="info" :src="require(`@/assets/share/sportIcon/${sportType}.png`)"/>
        </div>

        <!--        <baidu-map class="map" :center="center" :zoom="zoom" @ready="initMap"-->
        <!--                   :scroll-wheel-zoom="true" :map-style="mapStyle"-->
        <!--                   v-if="gpsData"></baidu-map>-->
        <canvas class="map" width="56" height="56" :id="canvasId" v-if="gpsData"></canvas>
    </div>
</template>

<script>
    import {GPS_transformation} from '@/utils/gpsToBD'

    export default {
        name: 'gpsBaidu',
        props: ['gpsData', 'canvasId', 'sportType'],
        data() {
            return {
                mapStyle: {styleJson: require('@/assets/share/home/custom_map_config.json')},
                map: '',
                BMap: '',
                center: '',
                zoom: 0
            }
        },
        mounted() {
            if (this.gpsData) {
                this.drawCanvas();
            }
        },
        methods: {
            // 地图初始化
            initMap({BMap, map}) {
                // map.setMapStyleV2({
                //     styleId: 'fa10145adf08e28d5af43c77b05027fc'
                // })
                this.map = map;
                this.BMap = BMap;
                if (this.gpsData) {
                    this.drawSportGPS();
                }
            },
            // 绘制地图轨迹
            drawSportGPS() {

                let point = this.gpsData;
                let pointArr = point.split(',');
                if (pointArr.length < 2) {
                    this.gpsData = '';
                }
                let lineList = [];
                for (let i = 0; i < pointArr.length - 1; i = i + 2) {
                    if (Math.abs(pointArr[i]) < 180 && Math.abs(pointArr[i + 1]) < 75 && pointArr[i] != 0 && pointArr[i + 1] != 0) {
                        if (lineList.length > 0) {
                            if (Math.abs(lineList[lineList.length - 1].lng - pointArr[i]) < 10 && Math.abs(lineList[lineList.length - 1].lat - pointArr[i + 1])) {
                                let bd = GPS_transformation(Number(pointArr[i + 1]), Number(pointArr[i]));
                                let bpPoint = new this.BMap.Point(bd[0], bd[1]);
                                lineList.push(bpPoint);
                            }
                        } else {
                            let bd = GPS_transformation(Number(pointArr[i + 1]), Number(pointArr[i]));
                            let bpPoint = new this.BMap.Point(bd[0], bd[1]);
                            lineList.push(bpPoint);
                        }

                    }
                }
                lineList = this.getKalmanData(lineList);
                var polyline = new this.BMap.Polyline(lineList,
                    {strokeColor: "#20D38F", strokeWeight: 3, strokeOpacity: 1});
                this.map.addOverlay(polyline);
                let view = this.map.getViewport(eval(lineList));
                this.zoom = view.zoom;
                this.center = view.center;

                let startIcon = new this.BMap.Icon(require("@/assets/share/home/start.png"), new this.BMap.Size(12, 12), {
                    imageSize: new this.BMap.Size(12, 12),
                    imageOffset: new this.BMap.Size(0, 0)
                });
                let startMarker = new this.BMap.Marker(lineList[0], {icon: startIcon}) // 创建标注
                this.map.addOverlay(startMarker)

                let endIcon = new this.BMap.Icon(require("@/assets/share/home/end.png"), new this.BMap.Size(12, 12), {
                    imageSize: new this.BMap.Size(12, 12),
                    imageOffset: new this.BMap.Size(0, 0)
                });
                let endMarker = new this.BMap.Marker(lineList[lineList.length - 1], {icon: endIcon}) // 创建标注
                this.map.addOverlay(endMarker)
            },
            // 卡尔曼滤波
            getKalmanData(points) {
                let result = [];
                let lat_Z = 0;
                let lat_P = 0;
                let lon_Z = 0;
                let lon_P = 0;
                for (let i = 0; i < points.length; i++) {
                    let point = points[i];
                    if (lat_Z == 0) {
                        lat_Z = point.lat;
                        lon_Z = point.lng;
                    }
                    let latparam = this.KalmanFilter(point.lat, lat_Z, lat_P);
                    lat_P = latparam[1];
                    lat_Z = latparam[0];
                    let lonparam = this.KalmanFilter(point.lng, lon_Z, lon_P)
                    lon_P = lonparam[1];
                    lon_Z = lonparam[0];
                    var npoint = new this.BMap.Point(lon_Z, lat_Z);
                    result.push(npoint);
                }
                return result;
            },
            KalmanFilter(T, Z, P) {
                let Q = 0.000001;
                let R = 0.000001;
                var P1 = Math.hypot(P, Q)
                let K = (Math.pow(P1, 2) / (Math.pow(P1, 2) + Math.pow(R, 2)))
                let Z1 = (Z + K * (T - Z))  //更新状态估计
                P1 = Math.sqrt((1 - K) * Math.pow(P1, 2))  //更新协方差估计
                return [Z1, P1];
            },
            drawCanvas() {
                let point = this.gpsData;
                let pointArr = point.split(',');
                if (pointArr.length < 2) {
                    this.gpsData = '';
                }
                let lineList = [];
                for (let i = 0; i < pointArr.length - 1; i = i + 2) {
                    if (Math.abs(pointArr[i]) < 180 && Math.abs(pointArr[i + 1]) < 75 && pointArr[i] != 0 && pointArr[i + 1] != 0) {
                        pointArr[i] = pointArr[i] * 100000 + 0.5;
                        pointArr[i + 1] = pointArr[i + 1] * 100000 + 0.5;
                        if (lineList.length > 0) {
                            if (Math.abs(lineList[lineList.length - 1].lng - pointArr[i]) < 1000000 && Math.abs(lineList[lineList.length - 1].lat - pointArr[i + 1]) < 1000000) {
                                let b = {
                                    "lng": Number(pointArr[i]),
                                    "lat": Number(pointArr[i + 1])
                                }
                                lineList.push(b);
                            }
                        } else {
                            let b = {
                                "lng": Number(pointArr[i]),
                                "lat": Number(pointArr[i + 1])
                            }
                            lineList.push(b);
                        }

                    }
                }
                let locationList = lineList;
                // canvas元素宽高
                let canvasHeight = 40,
                    canvasWidth = 40;

                // 遍历数据，把所有经、纬度分别添加数组中【目的：是得到各个方向轴的最大最小值】
                let amuXArr = [], // [22.54301, 22.51134, 22.50951, 22.51031, 22.54611]
                    amuYArr = []; // [113.98049, 114.06374, 114.06259, 114.06178, 113.96047]

                for (let i = 0; i < locationList.length; i++) {
                    amuXArr.push(locationList[i].lat);
                    amuYArr.push(locationList[i].lng);
                }

                // y轴需要进行取负操作 [-113.98049, -114.06374, -114.06259, -114.06178, -113.96047]
                amuYArr = amuYArr.map((item) => {
                    return item * -1;
                });

                // 拿到方向轴的最大最小值
                let xMax = Math.max(...amuXArr);
                let xMin = Math.min(...amuXArr);
                let yMax = Math.max(...amuYArr);
                let yMin = Math.min(...amuYArr);

                // 根据canvas宽高计算缩放级别
                let xScale = canvasWidth / (xMax - xMin);
                let yScale = canvasHeight / (yMax - yMin);
                let scale = xScale < yScale ? xScale : yScale;

                // 计算偏移量
                let xoffset = (canvasWidth - (xMax - xMin) * scale) / 2 - 8;
                let yoffset = (canvasHeight - (yMax - yMin) * scale) / 2 + 8;

                let canvas = document.getElementById(this.canvasId);
                var ctx = canvas.getContext("2d");
                var devicePixelRatio = window.devicePixelRatio || 1;
                canvas.width = 56 * devicePixelRatio;
                canvas.height = 56 * devicePixelRatio;
                ctx.scale(devicePixelRatio, devicePixelRatio);


                // 平移原点并旋转画布
                ctx.translate(0, canvasHeight);
                ctx.rotate(-Math.PI / 2);
                ctx.beginPath();

                // 根据偏移量移动点位并画图
                ctx.moveTo(
                    (amuXArr[0] - xMin) * scale + xoffset,
                    (yMax - amuYArr[0]) * scale + yoffset
                );

                for (let i = 1; i < amuXArr.length; i++) {
                    ctx.lineTo(
                        (amuXArr[i] - xMin) * scale + xoffset,
                        (yMax - amuYArr[i]) * scale + yoffset,
                    );
                }

                ctx.strokeStyle = '#1FE298';
                // ctx.closePath();
                var start = new Image();
                var end = new Image();
                start.src = require("@/assets/share/home/start.png");
                end.src = require("@/assets/share/home/end.png");
                start.onload = function () {
                    ctx.drawImage(
                        start,
                        (amuXArr[0] - xMin) * scale + xoffset - 6,
                        (yMax - amuYArr[0]) * scale + yoffset - 6,
                        12,
                        12
                    )
                }
                end.onload = function () {
                    ctx.drawImage(
                        end,
                        (amuXArr[amuXArr.length - 1] - xMin) * scale + xoffset - 6,
                        (yMax - amuYArr[amuXArr.length - 1]) * scale + yoffset - 6,
                        12,
                        12
                    )
                }
                ctx.stroke();
            }
        }
    }
</script>

<style scoped>
    .map {
        position: relative;
        width: 56px;
        height: 56px;
    }

    .no-gps {
        position: absolute;
        width: 36px;
        height: 36px;
        top: 10px;
        left: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/gpsBaidu.vue